import { HttpClient } from '../HttpClient';
/**
 * * Get Transaction List Data
 **/

export const GetTransactionListData = async ({id, PageNumber, RowsPerPage, search, datefrom, dateto, paymentstatus, employeestatus
}) => {
  try {
    const response = await HttpClient.get(
      `/api/instacash/statements/${id}/details`,
      {
        params: {
          PageNumber,
          RowsPerPage,
          search,
          datefrom,
          dateto,
          paymentstatus,
          employeestatus,
        },
      }
    );
    return await Promise.resolve(response);
  } catch (err) {
    return Promise.reject(err);
  }
};
